import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import type { VoiceCommandDoc } from '../../data/voiceCommandsDocs';
import { CommonIcon } from '../common/CommonIcon';
import { voiceCommandLabel } from './docs/voiceCommandsDocsShared';

interface VoiceModalListeningHintsExampleRowProps {
  cmd: VoiceCommandDoc;
  trySuffix: string;
}

export const VoiceModalListeningHintsExampleRow: FC<VoiceModalListeningHintsExampleRowProps> = ({
  cmd,
  trySuffix,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', px: 1 }}>
    <Stack direction="row" alignItems="flex-start" sx={{ gap: '6px', maxWidth: '100%', minWidth: 0 }}>
      <Box sx={{ flexShrink: 0, lineHeight: 0, pt: '2px' }}>
        <CommonIcon icon={cmd.icon} type="filled" size={14} color="var(--tg-theme-button-color)" />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Text
          style={{
            fontSize: 14,
            fontStyle: 'italic',
            lineHeight: 1.6,
            color: 'var(--tg-theme-text-color)',
            textAlign: 'left',
          }}
        >
          <span
            style={{ color: 'var(--tg-theme-button-color)', fontStyle: 'normal', fontWeight: 600 }}
          >
            {voiceCommandLabel(cmd)}
          </span>
          {trySuffix ? <span style={{ opacity: 0.7 }}> {trySuffix}</span> : null}
        </Text>
      </Box>
    </Stack>
  </Box>
);
